<template>
  <v-card color="#F5F5F5" class="back pa-4 mt-0 report-card">
    <v-card-title
      >1.12 -
      {{ $t('Calibrações agendadas x executadas - Acumulado') }}</v-card-title
    >
    <v-divider></v-divider>
    <v-alert type="error" class="mt-3 pa-0" v-if="!showChart">
      {{ $t('Nenhum calibração encontrado') }}
    </v-alert>
    <v-card-text v-else>
      <v-row justify="center">
        <v-col cols="12" lg="8">
          <BarChart
            :chart-data="calibrationScheduleExecutedChartData"
            :options="options"
          />
        </v-col>
      </v-row>
      <v-simple-table class="main-table" dense>
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-left"></th>
              <th class="text-left"></th>
              <th
                class="text-left"
                v-for="month in data.dataByMonth.map((x) => x.month)"
                :key="month"
              >
                {{ month }}
              </th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td style="max-width: 100px"></td>
              <td style="max-width: 100px">
                {{ $t('Calibração solicitada (interna)') }}
              </td>
              <td v-for="item in data.dataByMonth" :key="item.month">
                {{ item.internalCalibrationSchedule }}
              </td>
            </tr>
            <tr>
              <td style="max-width: 100px"></td>
              <td style="max-width: 100px">
                {{ $t('Calibração executada (interna)') }}
              </td>
              <td v-for="item in data.dataByMonth" :key="item.month">
                {{ item.internalCalibrationExecuted }}
              </td>
            </tr>
            <tr>
              <td style="max-width: 100px"></td>
              <td style="max-width: 100px">
                {{ $t('Calibração solicitada (total)') }}
              </td>
              <td v-for="item in data.dataByMonth" :key="item.month">
                {{ item.totalCalibrationSchedule }}
              </td>
            </tr>
            <tr>
              <td style="max-width: 100px"></td>
              <td style="max-width: 100px">
                {{ $t('Calibração executada (total)') }}
              </td>
              <td v-for="item in data.dataByMonth" :key="item.month">
                {{ item.totalCalibrationExecuted }}
              </td>
            </tr>
            <tr style="background: #0288d1">
              <td style="max-width: 100px"></td>
              <td style="max-width: 60px; color: white !important">
                {{ $t('Porcentagem (total)') }}
              </td>
              <td
                style="color: white !important"
                v-for="item in data.dataByMonth"
                :key="item.month"
              >
                {{ `${item.totalPercentage}%` }}
              </td>
            </tr>
            <tr style="background: #bbcf20">
              <td style="max-width: 100px"></td>
              <td style="max-width: 60px; color: white !important">
                {{ $t('Porcentagem (interna)') }}
              </td>
              <td
                style="color: white !important"
                v-for="item in data.dataByMonth"
                :key="item.month"
              >
                {{ `${item.percentage}%` }}
              </td>
            </tr>
            <!-- <tr style="background: orange">
              <td style="max-width: 100px"></td>
              <td style="max-width: 60px; color: white !important">Meta</td>
              <td
                style="color: white !important"
                v-for="item in data.dataByMonth"
                :key="item.month"
              >
                {{ `${data.goal}%` }}
              </td>
            </tr> -->
          </tbody>
        </template>
      </v-simple-table>
    </v-card-text>
  </v-card>
</template>

<script>
import ApiService from '../../../../../../services/ApiService'
import BarChart from '../../../../Reports/components/charts/barChart'

export default {
  props: {
    filter: Object,
  },
  components: {
    BarChart,
  },
  data() {
    return {
      apiService: new ApiService(),
      loading: false,
      calibrationScheduleExecuted: undefined,
      page: 1,
      showChart: true,
      totalPages: 1,
      pageSize: 7,
      percent: 0,
      options: {
        maintainAspectRatio: false,
        responsive: true,
        legend: {
          labels: {
            usePointStyle: true,
          },
        },
        scales: {
          yAxes: [
            {
              ticks: {
                beginAtZero: true,
              },
            },
          ],
          xAxes: [
            {
              ticks: {
                beginAtZero: true,
              },
            },
          ],
        },
      },
      calibrationScheduleExecutedChartData: {},
      calibrationSchedule: [],
      calibrationExecuted: [],
      internalCalibrationSchedule: [],
      internalcClibrationExecuted: [],
      labels: [],
      total: 0,
      data: {
        dataByMonth: [],
      },
    }
  },
  async created() {
    this.listcalibrationScheduleExecuted()
  },
  methods: {
    async listcalibrationScheduleExecuted() {
      await this.apiService
        .post('bigData/calibrationScheduleExecuted', this.filter)
        .then((response) => {
          this.data = response.content
        })
        .catch((err) => {})

      this.fillcalibrationScheduleExecutedChartData()
    },
    fillcalibrationScheduleExecutedChartData() {
      this.calibrationScheduleExecutedChartData = {
        labels: this.data.dataByMonth.map((x) => x.month),
        datasets: [
          {
            label: 'Execução total',
            data: this.data.dataByMonth.map((x) => x.totalPercentage),
            backgroundColor: '#0288d1',
            pointRadius: 5,
            pointHoverRadius: 10,
          },
          {
            label: 'Execução interna',
            data: this.data.dataByMonth.map((x) => x.percentage),
            backgroundColor: '#bbcf20',
            pointRadius: 5,
            pointHoverRadius: 10,
          },
        ],
      }
    },
  },
  watch: {
    page() {
      this.filter.page = this.page
      this.listcalibrationScheduleExecuted()
    },
  },
}
</script>
